import { createRoutine } from 'redux-saga-routines';

export const fetchOrganizationPortfolioSummary = createRoutine(
  'FETCH_ORG_PORTFOLIO_SUMMARY'
);

export const fetchAccountPortfolioSummary = createRoutine(
  'FETCH_ACC_PORTFOLIO_SUMMARY'
);

export const fetchOrganizationRenewalsSummary = createRoutine(
  'FETCH_ORG_RENEWALS_SUMMARY'
);

export const fetchAccountRenewalsSummary = createRoutine(
  'FETCH_ACC_RENEWALS_SUMMARY'
);

export const fetchCockpitSuccessPlans = createRoutine(
  'FETCH_COCKPIT_SUCCESS_PLANS'
);

export const fetchCockpitTasks = createRoutine('FETCH_COCKPIT_TASKS');

export const fetchCockpitPlaybooks = createRoutine('FETCH_COCKPIT_PLAYBOOKS');

export const createActionItemProcessRequest = createRoutine(
  'CREATE_ACTION_ITEM_PROCESS_REQUEST'
);

export const fetchActionItems = createRoutine('FETCH_ACTION_ITEMS');

export const fetchActionItemsWithId = createRoutine(
  'FETCH_ACTION_ITEMS_WITH_ID'
);

export const updateActionItemActivity = createRoutine(
  'UPDATE_ACTION_ITEM_ACTIVITY'
);
